/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-07-04
 */

/**
 * Required to ensure that Microsoft Lamexcel imports CSV as UTF-8
 * https://stackoverflow.com/a/155176
 */
const BYTE_ORDER_MARK = '\uFEFF';

export const ITEMS_HEADERS = BYTE_ORDER_MARK + 'code,area_code,area_name,name,details,strand\n';

export const ITEMS_EXAMPLE = '"EXA","Example Area Code","Example Area Name","Example Name","And example of what the details might look like","Example Strand"';

export const CONTENT_HEADERS = BYTE_ORDER_MARK + 'item_code,code,year,contents,context\n';

export const CONTENT_EXAMPLE = '"EXA","EXA_CON","Example Year","Example Contents","Example Context"';

const escapeValue = val => (val && (val.indexOf(',') >= 0 || val.indexOf('"') >= 0)) ? `"${val.replace(/\"/g, "\"\"")}"` : (val || '');

/**
 * Map an items object array into CSV data.
 * @param items Full items object array
 * @returns {string} CSV string
 */
export const getItemsAsCSV = items => {
	return ITEMS_HEADERS + (items ? items.map(item => (
		[item.code, item.area_code, item.area_name, item.name, item.details, item.strand].map(escapeValue).join(',')
	)).join('\n') : '');
};

/**
 * Map an items object array with nested content object arrays into syllabus content CSV data.
 * @param items Full items object array
 * @returns {string} CSV string
 */
export const getContentAsCSV = items => {
	return CONTENT_HEADERS + (items ? items.reduce((csv, item) => {
		csv += (item.content ? item.content.map(content => (
			[item.code, content.code, content.year, content.contents, content.context].map(escapeValue).join(',')
		)).join('\n') : '') + '\n';
		return csv;
	}, '') : '');
};


/**
 * Export a given string as a CSV file that is downloaded in the browser immediately.
 * @param name The name of the file
 * @param {string} data The CSV content
 */
export const exportFile = (name, data) => {
	const urlObject = window.URL || window.webkitURL || window;
	const blob = new Blob([data], {type: 'text/csv'});
	const link = document.createElement('a');
	link.href = urlObject.createObjectURL(blob);
	link.download = name;
	document.body.appendChild(link); // In Firefox, the element must be in the DOM to be clickable
	link.click();
	setTimeout(() => link.remove(), 10); // Delay removal from DOM to ensure adequate time for event to complete
};


// WEBPACK FOOTER //
// ./src/syllabus/csvExporter.js